/**
 * Pure numeric coercion for record values. Split from record-lens-utils so the
 * dashboard model (and anything else that only needs a number out of a field
 * value) can import it without record-lens-utils' runtime dependency on
 * `@mlx/contracts` — the marketing site's product bridge imports the dashboard
 * chart components by source path, and contracts resolve to type declarations
 * there.
 */

export function amountValue(value: unknown): number {
  const raw = String(value ?? "").replace(/[^0-9.-]/gu, "");
  const numeric = Number(raw);
  return Number.isFinite(numeric) ? numeric : 0;
}

export function percentDisplayValue(
  value: unknown,
  scale: "fraction" | "points" = "points",
): number {
  const numeric = amountValue(value);
  return scale === "fraction" ? numeric * 100 : numeric;
}
